import { jsx as r, jsxs as t, Fragment as p } from "../../_virtual/jsx-runtime.mjs";
import * as o from "react";
import { w as F } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import { listItemIcon as x, listItemRemoveIcon as R, loadingBar as w, fileNameCursor as S, uploadList as L, listItemStatus as T, fileName as _, popupImgContainer as j, popupName as y } from "./css/ReoUpload.mjs";
import d from "../ReoIcon/ReoIcon.mjs";
import h from "../../depend/classnames/index.mjs";
import { backgroundColor as E } from "../../assets/css/color.mjs";
import M from "../../Basic/LoadingBar/LoadingBar.mjs";
import O from "../ReoPopup/ReoPopup.mjs";
import { uploadListThemeTemplate as C } from "../../assets/css/themes/template/uploadTemplate.mjs";
import { CLOSE_ICON_NAME as W } from "./const.mjs";
import { ThemeConfigContext as A } from "../../assets/css/globalTheme.mjs";
const P = (l) => {
  const g = o.useCallback((a) => /* @__PURE__ */ r(
    d,
    {
      className: x,
      color: a.status === "uploading" ? "var(--icon-loading-color)" : "var(--color)",
      width: 15,
      spin: a.status === "uploading",
      name: a.status === "uploading" ? "icon-icon-loading-1" : "icon-attach-file"
    }
  ), []), m = o.useCallback((a) => {
    l == null || l.onRemove(a);
  }, [l]), c = o.useContext(A), f = o.useCallback((a) => {
    const s = (n) => {
      n.stopPropagation(), m(a);
    }, i = c.scene;
    return /* @__PURE__ */ r(
      d,
      {
        onClick: s,
        className: R,
        hoverColor: E.dark100,
        width: 20,
        name: W[i]
      }
    );
  }, [m, c.scene]), k = o.useCallback((a) => a.status === "uploading" ? /* @__PURE__ */ r(
    "span",
    {
      className: w,
      children: /* @__PURE__ */ r(
        M,
        {
          animation: !1,
          longBarWidth: "100%",
          shortBarWidth: `${a.percent}%`,
          longBarColor: C.item.loadingBar.longBarColor,
          shortBarColor: C.item.loadingBar.shortBarColor
        }
      )
    }
  ) : null, []), [v, u] = o.useState(!1), [e, N] = o.useState(), b = o.useCallback(
    (a) => {
      var s;
      return l.hasFileClickCb || (s = a.type) != null && s.match("image.*") ? S : null;
    },
    [l.hasFileClickCb]
  ), B = o.useCallback((a, s) => {
    var i, n;
    a.url && (i = a.type) != null && i.match("image.*") && (N(a), u(!0)), (n = l.onFileClick) == null || n.call(l, a, s);
  }, [l]), I = o.useCallback(() => {
    u(!1);
  }, []);
  return l.uploadFiles.length ? /* @__PURE__ */ t(p, { children: [
    /* @__PURE__ */ r("ul", { className: L, children: l.uploadFiles.map((a) => {
      var s;
      const i = (n) => {
        B(a, n);
      };
      return /* @__PURE__ */ r(
        "li",
        {
          className: h(
            T[a.status ?? "success"]
          ),
          children: ((s = l.listItemRender) == null ? void 0 : s.call(l, a)) ?? /* @__PURE__ */ t(p, { children: [
            g(a),
            /* @__PURE__ */ t(
              "span",
              {
                className: h(
                  _,
                  b(a)
                ),
                onClick: i,
                children: [
                  a.name,
                  k(a)
                ]
              }
            ),
            f(a)
          ] })
        },
        a.uid
      );
    }) }),
    /* @__PURE__ */ r(
      O,
      {
        width: "fit-content",
        onClose: I,
        open: v,
        theme: l == null ? void 0 : l.theme,
        children: /* @__PURE__ */ t(
          "div",
          {
            className: j,
            children: [
              /* @__PURE__ */ r(
                "img",
                {
                  src: e == null ? void 0 : e.url,
                  alt: ""
                }
              ),
              /* @__PURE__ */ r("span", { className: y, children: e == null ? void 0 : e.name })
            ]
          }
        )
      }
    )
  ] }) : null;
};
F(P, {});
//# sourceMappingURL=UploadList.mjs.map
